import {type TranslationObject} from '@colonist/i18n'
import {CA} from '../analytics/Analytics.ts'
import {createDivIn, createImgIn, createParagraphIn, setElementOnClick} from '../ui_utils/DomUtils.ts'
import {type LobbyImage} from '@colonist/types'
import {AudioManager, AudioType} from '@colonist/audio'

export interface DropdownContent {
    id: string
    text: TranslationObject
    class: string
    action?: () => void
    icon?: LobbyImage
}
export class UIComponentDropdownController {
    private readonly dropdownContainer: HTMLElement
    private readonly dropdownButton: HTMLElement
    readonly dropdownView: HTMLElement

    constructor(dropdownContent: DropdownContent[], dropdownParentId: string, hideDropdown: boolean, toggleVisibilityComponent: HTMLDivElement) {
        const dropdownContainers = document.getElementsByClassName('component-dropdown-container')
        for(const dropdownContainer of dropdownContainers) {
            const parent = dropdownContainer.parentElement as HTMLElement
            if(parent.id == dropdownParentId) {
                this.dropdownContainer = dropdownContainer as HTMLElement
                this.dropdownButton = toggleVisibilityComponent as HTMLElement
                this.dropdownView = this.dropdownContainer.children[1] as HTMLElement
            }
        }

        if(hideDropdown) {
            this.dropdownContainer.style.display = 'none'
            return
        }

        this.dropdownContainer.style.display = 'inline-block'
        if(this.dropdownButton == undefined) return
        if(this.dropdownView == undefined) return

        this.createDropdownContent(dropdownContent)

        setElementOnClick(this.dropdownButton, (event) => {
            const target = event.target as HTMLElement
            const targetInsideDropdownView = this.dropdownView.contains(target)
            if(targetInsideDropdownView) return
            this.dropdownButtonAction()
        })

        document.addEventListener('pointerdown', (event: PointerEvent) => {
            const target = event.target as HTMLElement
            const targetInsideContainer = this.dropdownContainer.contains(target)
            const targetInsideToggleContainer = toggleVisibilityComponent.contains(target)
            if(targetInsideContainer) return
            if(targetInsideToggleContainer) return
            this.hideDropdownMenuIfShown()
        })
    }

    private createDropdownContent(dropdownContent: DropdownContent[]) {
        this.dropdownView.replaceChildren()
        dropdownContent.forEach((content: DropdownContent) => {
            this.createDropdownContentElement(content)
        })
    }

    createDropdownContentElement(content: DropdownContent) {
        const dropdownContentContainer = createDivIn(this.dropdownView, '', content.id)
        if(content.icon != undefined) createImgIn(dropdownContentContainer, content.icon)
        createParagraphIn(dropdownContentContainer, content.text, content.class)
        setElementOnClick(dropdownContentContainer, () => {
            if(content.class.includes('component-dropdown-disabled')) return
            if(content.action != undefined) content.action()
            this.hideDropdownMenuIfShown()
        }, true)
    }

    dropdownButtonAction() {
        AudioManager.play(AudioType.Click)
        CA.sendGoogleAnalyticsEvent(CA.Category.Profile, CA.Label.ClickedProfileDropdown)
        this.dropdownView.classList.toggle('show')
    }

    hideDropdownMenuIfShown() {
        const dropDownViewShown = this.dropdownView.classList.contains('show')
        if(!dropDownViewShown) return
        this.dropdownView.classList.toggle('show')
    }

    updateDropdownState(dropdownContent: DropdownContent[]) {
        if(this.dropdownView?.replaceChildren == undefined) return

        this.dropdownView.replaceChildren()
        this.createDropdownContent(dropdownContent)
    }
}
